"use strict";

(function () {

    $.widget('khis.participantSelector', {
        options: {
            title: 'Intervinientes',
            roleTitle: 'Função',
            professionalTitle: 'Professional',
            professionalCeduleTitle: 'Cédula',
            noRecordsLabel: 'Não existem registos.',
            addTeamTranslation: 'Equipas Cirúrgicas.',
            addLastTeamSurgery: 'Adicionar equipa da última cirurgia',
            addSurgicalActs: 'Adicionar ato médico',
            roleList: [],
            inputWidth: 220,
            url: '',
            urlParams: {},
            professionalCategory: null,
            blockCategoryFilter: 0,
            componentStatus: 0,
            teamType: 0,
            readOnly: false,
            filterBySoftware: null,
            inBackoffice: false,
            drawLastTeamSurgery: false,
            roleMedicalActs: 'Actos médicos',
            nosologic_group_surgical_acts: []
        },
        inputWidth: 220,
        nextParticipantId: 0,
        roleList: [],
        readOnly: false,
        blockCategoryFilter: 0,
        componentStatus: 0,
        teamType: 0,
        _create: function () {
            this.inputWidth = this.options.inputWidth;
            this.roleList = this.options.roleList;
            this.nextParticipantId = 0;
            this.readOnly = this.options.readOnly;
            this.blockCategoryFilter = this.options.blockCategoryFilter;
            this.componentStatus = this.options.componentStatus;
            this.teamType = this.options.teamType;
            this.nosologic_group_surgical_acts = this.options.nosologic_group_surgical_acts;

            this._drawHeader();
            this._drawSearch();
            this._drawTableHeader();
            this._drawComponent();

            this.loading.hide();
            this.container.show();
        },
        _init: function () {
            this._on({
                'click button[role=multiple_search]': function () {
                    this.searchProfessional();
                }
            });

            this._on({
                'click button[role=add]': function () {
                    this.addParticipants([
                        {fixedRole: false, role_id: '', role_description: '', participant_id: '', participant_name: '', participant_cedule: '', participant_surgical_act: ''}
                    ]);
                }
            });

            this._on({
                'click button[role=single_search]': function (evt) {
                    this.searchSingleProfessional(evt.target);
                }
            });

            this._on({
                'click span[role=remove_participant]': function (evt) {
                    this.onParticipantRemove($(evt.target));
                }
            });

            this._on({
                'click button[role=clear_participant]': function (evt) {
                    this.onParticipantClear($(evt.target));

                }
            });

            this._on({
                'click span[role=add_team]': function () {
                    this.searchSurgicalTeams();
                }
            });

            this._on({
                'click span[role=add_last_participants_surgery]': function () {
                    this.addLastSurgeryParticipants();
                }
            });

            this._on({
                'change select[role=participant_surgical_act]': function (evt, changes) {
                    debug.log('activate');
                    this.onMultiSelectChange(evt, changes);
                }
            });
        },
        _drawComponent: function () {
            this.component = $('<div></div>');
            this.loading = $('<div role="loading" style="margin: 0 auto;"><img style="margin: auto" src="/assets/progress_bar.gif" alt="Loading" align="middle"></div>');
            this.container = $('<div class="bootstrap" style="display: none;"></div>');

            // Search
            if (!this.readOnly) {
                this.container.append(this.inputElem);
                this.container.append(this.searchBtn);
                this.container.append(this.createBtn);
                this.container.append(this.teamLink);
                this.container.append(this.lastTeamSurgery);
                this.container.append('<div class="spacer"></div>');
            }

            this.container.append(this.tableHeader);
            this.container.append(this.noRecordsElem);

            this.component.append(this.header);

            this.component.append(this.loading);
            this.component.append(this.container);

            this.element.append(this.component);

            this.component.find('select[role=participant_surgical_act]').chosen();

        },
        _drawHeader: function () {
            var top_line = '<div style="padding: 4px; border-bottom: 1px solid #a9d9e0; margin-bottom: 8px;">' +
                '<span style="font-weight: bold;">' + this.options.title + '</span>' +
                '</div>';

            this.header = $(top_line);
        },
        _drawSearch: function () {
            this.inputElem = $('<input type="text" value="" style="width:' + this.inputWidth + 'px;" class="float_left input_grad" role="search">');
            this.searchBtn = $('<button role="multiple_search" type="button" class="float_left square_btn search_square_btn" tabindex="-1" style="margin-left: 4px;"></button>');
            this.createBtn = $('<button role="add" type="button" class="float_left square_btn add_square_btn" tabindex="-1" style="margin-left: 4px;"></button>');
            if ( !this.options.inBackoffice == true) {
                this.teamLink = $('<span class="float_left add_team txt_link" style="margin-left: 4px; line-height: 30px;" role="add_team">' + GlobalTranslations['APP_LABEL.2450'] + '</span>');
                if(this.options.drawLastTeamSurgery == true){
                    this.lastTeamSurgery = $('<span class="float_left add_last_participants_surgery txt_link" style="margin-left: 15px; line-height: 30px;" role="add_last_participants_surgery">' + GlobalTranslations['APP_LABEL.2454'] + '</span>');
                }
            }
        },
        _drawTableHeader: function () {
            debug.log("Controi a tabela");

            this.tableHeader = $('<table cellpadding="0" cellspacing="0" style="margin-top: 8px;" role="participants_list"></table>');
            var headers = $('<tr style="color: rgb(0, 160, 175); font-weight: bold; text-transform: uppercase; border-bottom: solid 1px #DDDDDD;"></tr>');

            if (!this.readOnly) {
                headers.append('<th style="padding: 4px 8px; width: 16px; text-align: left;"></th>');
                headers.append('<th style="padding: 4px 8px; width: 170px; text-align: left;"><div class="form_label form_label_mandatory"><label for="participant_role">' + this.options.roleTitle + '</label></div></th>');
            } else {
                headers.append('<th style="padding: 4px 8px; width: 170px; text-align: left;"><div><label>' + this.options.roleTitle + '</label></div></th>');
            }


            headers.append('<th style="padding: 4px 8px; width: 250px; text-align: left;">' + this.options.professionalTitle + '</th>');
            headers.append('<th style="padding: 4px 8px; width: 220px; text-align: left;">' + this.options.professionalCeduleTitle + '</th>');
            headers.append('<th style="padding: 4px 8px; width: 220px; text-align: left;">' + this.options.roleMedicalActs + '</th>');

            this.tableHeader.append(headers);

            this.noRecordsElem = $('<span style="font-style: italic; display: none;" role="no_records">' + this.options.noRecordsLabel + '</span>');

        },
        addParticipants: function (participants) {

            debug.log("ADD PARTICIPANT");
            var
                table = this.tableHeader,
                row,
                participant,
                combo,
                colRemove,
                colRole,
                colFixedRole,
                colProfessional,
                colCedule,
                colRemoveStatus3,
                colRoleStatus3,
                colProfessionalStatus3,
                colCeduleStatus3,

                colTdSurgicalActs,
                colSelectSurgicalActs,
                colOptionSurgicalActs,
                colSurgicalActs,
                colSelectSurgicalActsStatus3;

            colRemove = '<td style="padding: 4px 0px; width: 16px; border-bottom: solid 1px #DDDDDD; "><span class="ui-icon ui-icon-red ui-icon-trash" role="remove_participant" style="cursor: pointer"></span></td>';
            colRemoveStatus3 = '<td style="padding: 4px 0px; width: 16px; border-bottom: solid 1px #DDDDDD; "></td>';

            colRole = '<td style="padding: 4px 8px; width: 170px; border-bottom: solid 1px #DDDDDD; text-align: left; vertical-align: top;">' +
                '<select role="participant_role" name="participant_role" class="input_grad form_field_mandatory" style="min-width: 130px;"></select>' +
                '</td>';

            colRoleStatus3 = '<td style="padding: 4px 8px; width: 170px; border-bottom: solid 1px #DDDDDD; text-align: left; vertical-align: top;">' +
                '<select role="participant_role" name="participant_role" class="input_grad form_field_mandatory" disabled="disabled" style="min-width: 130px;"></select>' +
                '</td>';

            colFixedRole = '<td style="padding: 4px 8px; width: 170px; border-bottom: solid 1px #DDDDDD; text-align: left; vertical-align: top;">' +
                '<input type="hidden" class="input_grad form_field_mandatory" value="${ROLE}" role="participant_role">' +
                '<input type="text" disabled="disabled" class="input_grad" style="min-width: 130px;" name="participant_role" value="${ROLE_DESC}">' +
                '</td>';

            colProfessional = '<td style="padding: 4px 8px; width: 250px; border-bottom: solid 1px #DDDDDD; text-align: left; vertical-align: top;">' +
                '<input type="hidden" role="participant_id" value="${PARTICIPANT_ID}">' +
                '<input type="text" disabled=disabled name="professional_name" value="${PARTICIPANT_NAME}" class="input_grad" role="participant_name">' +
                '<button role="single_search" class="square_btn search_square_btn" style="margin-left: -1px;"></button>' +
                '<button role="clear_participant" class="square_btn close_square_btn_red" style="margin-left: -1px; display: none;"></button>' +
                '</td>';

            colProfessionalStatus3 = '<td style="padding: 4px 8px; width: 250px; border-bottom: solid 1px #DDDDDD; text-align: left; vertical-align: top;">' +
                '<input type="hidden" role="participant_id" value="${PARTICIPANT_ID}">' +
                '<input type="text" name="professional_name" value="${PARTICIPANT_NAME}" class="input_grad" disabled="disabled" role="participant_name">' +
                '</td>';

            colCedule = '<td style="padding: 4px 8px; width: 170px; border-bottom: solid 1px #DDDDDD; text-align: left; vertical-align: top;">' +
                '<input type="text" name="cedule_number" class="input_grad" role="participant_cedule" value="${PARTICIPANT_CEDULE}">' +
                '</td>';

            colCeduleStatus3 = '<td style="padding: 4px 8px; width: 170; border-bottom: solid 1px #DDDDDD; text-align: left; vertical-align: top;">' +
                '<input type="text" name="cedule_number" class="input_grad" disabled="disabled" role="participant_cedule" value="${PARTICIPANT_CEDULE}">' +
                '</td>';



            colTdSurgicalActs = '<td style="padding: 4px 8px; width: 170; border-bottom: solid 1px #DDDDDD; text-align: left; vertical-align: top;"></td>';

            colSelectSurgicalActs = '<select name="surgical_act" role="participant_surgical_act" multiple="multiple" class="input_grad" style="height: 31px; width: 250px;"></select>';
            colSelectSurgicalActsStatus3 = '<select name="surgical_act" role="participant_surgical_act" multiple="multiple" class="input_grad" disabled="disabled" style="height: 31px; width: 250px;"></select>';

            //var colTdSurgicalActs = $('<td style="padding: 4px 8px; width: 170; border-bottom: solid 1px #DDDDDD; text-align: left; vertical-align: top;"></td>');
            //var colSelectSurgicalActs = $('<select name="surgical_act" role="participant_surgical_act" multiple="multiple" class="input_grad" style="height: 31px; width: 250px;"></select>');


            if (participants.length <= 0) {
                this.tableHeader.hide();
                this.noRecordsElem.show();

            } else {
                this.noRecordsElem.hide();
                this.tableHeader.show();
            }

            for (var i = 0; i < participants.length; i++) {
                participant = participants[i];

                row = $('<tr class="participant_row" data-index="' + this.nextParticipantId + '" data-flg_surgical_team="'+ participant.flg_surgical_team + '" ></tr>');

                if (participant.participant_name == null) {
                    participant.participant_name = '';
                }
                if (participant.participant_cedule == null) {
                    participant.participant_cedule = '';
                }

                if (this.componentStatus == 3 /* surgical intervention - recovery */) {
                    var selectToAppend;
                    if (participant.role_id == 8 /* recovery nurse */ || participant.role_id == 10 /* recovery auxiliary */ || participant.role_id == '') {

                        if (this.teamType == 2) {
                            participant.role_id = 8;
                        } else if (this.teamType == 3) {
                            participant.role_id = 10;
                        } else {
                            participant.role_id = '';
                        }

                        row.append(colRemove);
                        row.append(colRoleStatus3);

                        row.append(colProfessional.replace('${PARTICIPANT_ID}', (participant.participant_id ? participant.participant_id : '')).replace('${PARTICIPANT_NAME}', participant.participant_name));
                        row.append(colCedule.replace('${PARTICIPANT_CEDULE}', participant.participant_cedule));

                        selectToAppend = $(colSelectSurgicalActs); //enabled
                        //selectToAppend = $(colSelectSurgicalActsStatus3); //disabled

                    } else if(!participant.role_id){

                        if (this.teamType == 2) {
                            participant.role_id = 8;
                        } else if (this.teamType == 3) {
                            participant.role_id = 10;
                        } else {
                            participant.role_id = '';
                        }

                        row.append(colRemove);
                        row.append(colRoleStatus3);

                        row.append(colProfessional.replace('${PARTICIPANT_ID}', (participant.participant_id ? participant.participant_id : '')).replace('${PARTICIPANT_NAME}', participant.participant_name));
                        row.append(colCedule.replace('${PARTICIPANT_CEDULE}', participant.participant_cedule));

                        selectToAppend = $(colSelectSurgicalActs); //enabled
                        //selectToAppend = $(colSelectSurgicalActsStatus3); //disabled
                    } else {
                        row.append(colRemoveStatus3);
                        row.append(colRoleStatus3);

                        row.append(colProfessionalStatus3.replace('${PARTICIPANT_ID}', (participant.participant_id ? participant.participant_id : '')).replace('${PARTICIPANT_NAME}', participant.participant_name));
                        row.append(colCeduleStatus3.replace('${PARTICIPANT_CEDULE}', participant.participant_cedule));

                        selectToAppend = $(colSelectSurgicalActs); //enabled
                        //selectToAppend = $(colSelectSurgicalActsStatus3); //disabled
                    }

                    /*########################
                    * SURGICAL MEDICAL ACTS
                    #########################*/
                    colOptionSurgicalActs = '<option value="-999">Todos</option>';

                    var particip_associated_surg_acts = [];

                    if (participant.surg_associated_medical_acts){

                        //particip_associated_surg_acts = participant.surg_associated_medical_acts.replace('{', '').replace('}', '').split(',');

                        particip_associated_surg_acts = JSON.parse(participant.surg_associated_medical_acts);
                        debug.log('parse_participants', participant.surg_associated_medical_acts, particip_associated_surg_acts);
                    }

                    if ( $('[nosologic-group]').length > 0 ) {
                        colSurgicalActs = this.drawSurgicalActs(particip_associated_surg_acts, this.getSurgicalActs());

                    }else{
                        var multiSelect = '';
                        var surgicalActs = this.nosologic_group_surgical_acts; //this.getSurgicalActs();
                        var surgicalActsMergedUniques = [];

                        $.each(surgicalActs, function (index, elem) {
                            var uniq_ids = [];
                            $.each(surgicalActsMergedUniques, function(idx, uniq){
                                uniq_ids.push(uniq.data);
                            });

                            //if($.inArray(elem.data, uniq_ids) === -1) {
                                surgicalActsMergedUniques.push(elem);
                            //}
                        });


                        multiSelect = this.drawSurgicalActs(particip_associated_surg_acts, surgicalActsMergedUniques);

                        colSurgicalActs = multiSelect;
                    }

                    //var selectToAppend = $(colSelectSurgicalActsStatus3);
                    var tdSurgicalActsToAppend = $(colTdSurgicalActs);

                    selectToAppend.append(colOptionSurgicalActs);
                    selectToAppend.append(colSurgicalActs);
                    tdSurgicalActsToAppend.append(selectToAppend);

                    row.append(tdSurgicalActsToAppend);

                    /*#######################
                    * SURGICAL MEDICAL ACTS
                    #########################*/

                    table.append(row);

                    if (!participant.fixedRole) {
                        combo = row.find('select[role=participant_role]');
                        combo.chosen();

                        GlobalFn.updateLookupList(combo, this.roleList, null, {prevVal: participant.role_id});
                    }

                    var combo_multiple = row.find('select[role=participant_surgical_act]');
                    combo_multiple.chosen();
                    combo_multiple.find('option').remove();
                    combo_multiple.append(colOptionSurgicalActs);
                    combo_multiple.append(colSurgicalActs);

                    combo_multiple.trigger('liszt:updated');

                } else {
                    if (participant.fixedRole) {
                        row.append($('<td style="padding: 4px 0px; width: 16px; border-bottom: solid 1px #DDDDDD; "></td>'));
                        row.append(colFixedRole.replace('${ROLE}', participant.role_id).replace('${ROLE_DESC}', participant.role_description));
                    } else {
                        row.append(colRemove);
                        row.append(colRole);
                    }

                    row.append(colProfessional.replace('${PARTICIPANT_ID}', (participant.participant_id ? participant.participant_id : '')).replace('${PARTICIPANT_NAME}', participant.participant_name));
                    row.append(colCedule.replace('${PARTICIPANT_CEDULE}', participant.participant_cedule));

                    /*#######################
                     * SURGICAL MEDICAL ACTS
                     #########################*/
                    colOptionSurgicalActs = '<option value="-999">Todos</option>';

                    var particip_associated_surg_acts = [];

                    if (participant.surg_associated_medical_acts){

                        //particip_associated_surg_acts = participant.surg_associated_medical_acts.replace('{', '').replace('}', '').split(',');
                        particip_associated_surg_acts = JSON.parse(participant.surg_associated_medical_acts);
                        debug.log('parse_participants', participant.surg_associated_medical_acts, particip_associated_surg_acts);
                    }

                    if ( $('[nosologic-group]').length > 0 ) {
                        colSurgicalActs = this.drawSurgicalActs(particip_associated_surg_acts, this.getSurgicalActs());

                    }else{
                        var multiSelect = '';

                        var surgicalActs = this.nosologic_group_surgical_acts; //this.getSurgicalActs(); XXX

                        var surgicalActsMergedUniques = [];

                        $.each(surgicalActs, function (index, elem) {
                            var uniq_ids = [];
                            $.each(surgicalActsMergedUniques, function(idx, uniq){
                                uniq_ids.push(uniq.data);
                            });

                            //if($.inArray(elem.data, uniq_ids) === -1) {
                                surgicalActsMergedUniques.push(elem);
                            //}
                        });


                        multiSelect = this.drawSurgicalActs(particip_associated_surg_acts, surgicalActsMergedUniques);

                        colSurgicalActs = multiSelect;
                    }

                    var selectToAppend = $(colSelectSurgicalActs);
                    var tdSurgicalActsToAppend = $(colTdSurgicalActs);

                    selectToAppend.append(colOptionSurgicalActs);
                    selectToAppend.append(colSurgicalActs);
                    tdSurgicalActsToAppend.append(selectToAppend);

                    row.append(tdSurgicalActsToAppend);
                    /*#######################
                     * SURGICAL MEDICAL ACTS
                     #########################*/

                    table.append(row);

                    if (!participant.fixedRole) {
                        combo = row.find('select[role=participant_role]');
                        combo.chosen();
                        GlobalFn.updateLookupList(combo, this.roleList, null, {prevVal: participant.role_id});
                    }


                    var combo_multiple = row.find('select[role=participant_surgical_act]');
                    combo_multiple.chosen();
                    combo_multiple.find('option').remove();
                    combo_multiple.append(colOptionSurgicalActs);
                    combo_multiple.append(colSurgicalActs);

                    combo_multiple.trigger('liszt:updated');
                }

                if (participant.participant_id) {
                    row.find('[role=participant_name]').attr('disabled', 'disabled');
                    row.find('button[role=single_search]').hide();
                    row.find('button[role=clear_participant]').show();
                }


                this.nextParticipantId++;

            }
        },
        addParticipantsReadOnly: function (participants) {
            var
                table = this.tableHeader,
                row,
                participant,
                colRole,
                colProfessional,
                colCedule,
                colSurgMedicalActs;

            if (participants.length > 0) {
                colRole = '<td style="padding: 4px 8px; width: 170px; border-top: solid 1px #DDDDDD; text-align: left;"><span>${ROLE_DESC}</span></td>';
                colProfessional = '<td style="padding: 4px 8px; width: 330px; border-top: solid 1px #DDDDDD; text-align: left;"><span>${PARTICIPANT_NAME}</span></td>';
                colCedule = '<td style="padding: 4px 8px; width: 250px; border-top: solid 1px #DDDDDD; text-align: left;"><span>${PARTICIPANT_CEDULE}</span></td>';
                colSurgMedicalActs = '<td style="padding: 4px 8px; width: 250px; border-top: solid 1px #DDDDDD; text-align: left;"><span>${PARTICIPANT_SURG_MEDICAL_ACTS}</span></td>';

                this.noRecordsElem.hide();
                table.show();

                for (var i = 0; i < participants.length; i++) {
                    participant = participants[i];

                    if (participant.participant_name || participant.participant_cedule) {
                        row = $('<tr class="participant_row"></tr>');

                        if (participant.participant_name == null) {
                            participant.participant_name = '';
                        }
                        if (participant.participant_cedule == null) {
                            participant.participant_cedule = '';
                        }

                        row.append(colRole.replace('${ROLE_DESC}', participant.role_description));
                        row.append(colProfessional.replace('${PARTICIPANT_NAME}', participant.participant_name));
                        row.append(colCedule.replace('${PARTICIPANT_CEDULE}', participant.participant_cedule));

                        row.append(colSurgMedicalActs.replace('${PARTICIPANT_SURG_MEDICAL_ACTS}', participant.surg_associated_medical_acts_desc));

                        table.append(row);
                    }

                }

                if (table.find('tr.participant_row').length == 0) {
                    table.hide();
                    this.noRecordsElem.show();
                }

            } else {
                table.hide();
                this.noRecordsElem.show();
            }
        },
        updateParticipant: function (index, participant) {
            var row = this.tableHeader.find('tr[data-index=' + index + ']');

            $(row).find('[role=participant_id]').val(participant.participant_id);
            $(row).find('[role=participant_name]').val(participant.participant_name).attr('disabled', 'disabled');
            $(row).find('[role=participant_cedule]').val(participant.participant_cedule);
            $(row).data('flg_surgical_team', participant.flg_surgical_team);

            $(row).find('button[role=single_search]').hide();
            $(row).find('button[role=clear_participant]').show();
        },
        onParticipantClear: function (elem) {



            var row = $(elem).closest('tr');

            debug.log("Clear participant", $(row).data('flg_surgical_team') );

            $(row).find('[role=participant_id]').val(null);
            $(row).find('[role=participant_name]').val(null); //.removeAttr('disabled');
            $(row).find('[role=participant_cedule]').val(null);
            $(row).data('flg_surgical_team', null);
            $(row).find('button[role=clear_participant]').hide();
            $(row).find('button[role=single_search]').show();
            $(row).find('[role=participant_surgical_act]').val(null);

        },
        searchProfessional: function () {

            debug.log("SEARCH HERE");

            Hades.showLoading();

            var that = this;
            var params = {
                id: that.element.attr('id')
            };

            $.get('/professional/new_search_modal', {search: $('#participant_name').val(), filter: that.options.professionalCategory, category: that.options.professionalCategory, block_category_filter: that.blockCategoryFilter, filter_by_software: that.options.filterBySoftware, width: $(window).width(), height: $(window).height()}, null, "html")
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    $.fancybox({content: data});

                    $('#professional-search-modal-ct').bind('professionalSelected', function (evt, data) {
                        that.onParticipantSelected(evt, data, params);
                    });

                    Hades.hideLoading();
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    Hades.hideLoading();
                });
        },
        searchSurgicalTeams: function () {

            Hades.showLoading();

            var that = this;
            var params = {
                id: that.element.attr('id')
            };

            $.get('/operating_room/surgical_proposal/search_surgical_teams_modal', {team_type_id: that.options.teamType, width: $(window).width(), height: $(window).height()}, null, "html")
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    $.fancybox({content: data});

                    $('#surgical-teams-search-modal-ct').bind('surgicalTeamSelected', function (evt, data) {
                        that.onSurgicalTeamSelected(evt, data, params);
                    });

                    Hades.hideLoading();
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    Hades.hideLoading();
                });
        },
        addLastSurgeryParticipants: function () {

            var that = this;
            var params = {
                id: that.element.attr('id')
            };

            $.get('/operating_room/operating_theater/get_last_surgery_participants_list', {team_type_id: that.options.teamType, physical_space_id: $('#physical_space_id').val()})
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    that.onLastSurgicalPartcipantsSelected(data, params);

                })
                .fail(function (xhr, status, error) {

                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    Hades.hideLoading();
                });
        },
        onParticipantSelected: function (evt, data, params) {

            debug.log("onParticipantSelected");

            $.fancybox.close(true);
            if (data && data.professionals.length > 0) {
                $.each(data.professionals, function (index, elem) {
                    elem.participant_id = elem.professional_id;
                    elem.participant_name = elem.professional_name;
                    elem.participant_cedule = elem.cedule_number;
                    elem.flg_surgical_team = false;
                });

                $('#' + params.id).participantSelector('addParticipants', data.professionals);

            }
        },
        onSurgicalTeamSelected: function (evt, data, params) {
            var participants = [];

            this.getSurgicalActs();

            $.fancybox.close(true);

            debug.log("onSurgicalTeamSelected", data);


            $.each(data.team_detail.rows, function (index, elem) {
                var participant ={};
                participant.participant_id = elem.professional_id;
                participant.participant_name = elem.professional_name;
                participant.participant_cedule = elem.cedule_number;
                participant.role_id = elem.professional_role_id;
                participant.role_description = elem.professional_role_desc;
                participant.flg_surgical_team = true;
                if (elem.professional_role_id == 1 /*Main Surgeon*/) {
                    participant.fixedRole = true;
                }

                participants.push(participant);
            });

            debug.log("participants", participants);

            $('.participant_row').each(function (idx, elem) {
                debug.log("Já inserido", $(elem).data('flg_surgical_team') ,$(elem).find("td input[role='participant_name']").val(), $(elem).find("td input[role='participant_role']").val(), $(elem).find("td input[name='participant_role']").val() );

                var already_participant = {};

                if($(elem).find("td input[role='participant_id']").val() != ""){
                    if ( $(elem).data('flg_surgical_team') == false || $(elem).data('flg_surgical_team') == 'f' ||  $(elem).data('flg_surgical_team') == 'undefined' || $(elem).data('flg_surgical_team') == null ){

                        already_participant.participant_id = $(elem).find("td input[role='participant_id']").val();
                        already_participant.participant_name = $(elem).find("td input[role='participant_name']").val();
                        already_participant.participant_cedule = $(elem).find("td input[role='participant_cedule']").val();
                        already_participant.role_id = $(elem).find("td select[role='participant_role']").val();
                        already_participant.role_description = $(elem).find("td select[name='participant_role']").val();
                        already_participant.flg_surgical_team = false;

                        participants.push(already_participant);

                    }

                }

            });

            debug.log("participants 2", participants);


            this.tableHeader.find('tr.participant_row').remove();

            // Draw
            if (this.readOnly) {
                this.addParticipantsReadOnly(participants);
            } else {
                this.addParticipants(participants);
            }

            this.loading.hide();
            this.container.show();

        },
        onLastSurgicalPartcipantsSelected: function (data, params) {
            var participants = [];

            $.each(data, function (index, elem) {

                var participant ={};

                participant.participant_id = elem.professional_id;
                participant.participant_name = elem.professional_name;
                participant.participant_cedule = elem.cedule_number;
                participant.role_id = elem.professional_role_id;
                participant.role_description = elem.professional_role_desc;

                if (elem.professional_role_id == 1 /*Main Surgeon*/) {
                    participant.fixedRole = true;
                }

                participants.push(participant);
            });

            this.tableHeader.find('tr.participant_row').remove();

            // Draw
            if (this.readOnly) {
                this.addParticipantsReadOnly(participants);
            } else {
                this.addParticipants(participants);
            }

            this.loading.hide();
            this.container.show();

        },
        searchSingleProfessional: function (elem) {

            debug.log("SINGLE SEARCH HERE");

            var that = this, row = $(elem).closest('tr');

            var callbackParams = {
                id: that.element.attr('id'),
                index: $(row).data('index')
            };

            Hades.showLoading();

            var params = {
                search: $(row).find('[role=participant_name]').val(),
                filter: that.options.professionalCategory,
                category: that.options.professionalCategory,
                block_category_filter: that.blockCategoryFilter,
                width: $(window).width(),
                height: $(window).height(),
                filter_by_software: that.options.filterBySoftware
            };

            $.get('/professional/search_modal', params, null, "html")
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    $.fancybox({content: data});

                    debug.log("SUCCESS", data);
                    $('#professional-search-modal-ct').bind('professionalSelected', function (evt, data) {
                        that.onSingleParticipantSelected(evt, data, callbackParams);
                    });

                    Hades.hideLoading();
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    Hades.hideLoading();
                });
        },
        onSingleParticipantSelected: function (e, data, params) {

            $.fancybox.close(true);

            var participant = data;
            participant.participant_id = data.id;
            participant.participant_name = data.name;
            participant.participant_cedule = data.cedule;
            participant.index = params.index;
            participant.flg_surgical_team = false;

            $('#' + params.id).participantSelector('updateParticipant', params.index, participant)
        },
        loadParticipants: function () {

            this.container.hide();
            this.loading.show();

            var that = this;

            $.getJSON(this.options.url, this.options.urlParams)
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    // Clear all participants
                    that.tableHeader.find('tr.participant_row').remove();

                    debug.log('loadParticipants :', data);

                    // Draw
                    if (that.readOnly) {
                        that.addParticipantsReadOnly(data.participants);
                    } else {
                        that.addParticipants(data.participants);
                    }

                    that.loading.hide();
                    that.container.show();
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    Hades.hideLoading();
                });
        },
        getParticipants: function () {
            var participants = [];

            this.tableHeader.find('tr.participant_row').each(function (i, tr) {

                var ng_surgical_acts = [];

                $(tr).find('[role=participant_surgical_act] option').each(function(i, opt){
                    //debug.log('participantSelector:getParticipants - ng_surgical_acts - SELECT OPT', opt);

                    if ($(opt).attr('selected') == "selected"){

                        ng_surgical_acts.push({
                            ng_index: $(opt).data('ng_index'),
                            surgical_act_id: $(opt).val(),
                            laterality_id: $(opt).data('lateralization')
                        });
                    }
                });

                debug.log('participantSelector:getParticipants - ng_surgical_acts', ng_surgical_acts);

                participants.push({
                    roleId: $(tr).find('[role=participant_role]').val(),
                    participantId: $(tr).find('[role=participant_id]').val(),
                    participantName: $(tr).find('[role=participant_name]').val(),
                    participantCedule: $(tr).find('[role=participant_cedule]').val(),
                    flg_surgical_team: $(tr).data('flg_surgical_team'),

                    ng_surgical_acts: ng_surgical_acts
                });
            });

            return participants;
        },
        onParticipantRemove: function(elem){

            $(elem).closest('tr').remove();

            if (this.element.find('.participant_row').length == 0) {
                this.tableHeader.hide();
                this.noRecordsElem.show();
            }
        },
        getSurgicalActs: function () {

            var surgicalActs = [];
            var surgicalActsMerged = [];
            var surgicalActsMergedUniques = [];

            if ( $('[nosologic-group] .surgical_act_row').length > 0 ) {
                debug.log('getSurgicalActs : nosologic_group: ', $('[nosologic-group]').length);
                $.each($('[nosologic-group]'), function (index, elem) {

                    var ng_surgical_acts = $(elem).nosologicGroup('getSurgicalActs');


                    $.each(ng_surgical_acts, function (i, ng_elem) {
                        ng_elem.ng_index = index;
                    });

                    debug.log('nosologic_group: ', ng_surgical_acts);

                    surgicalActs.push(ng_surgical_acts);

                });

                $.each(surgicalActs, function (index, elem) {
                    $.merge(surgicalActsMerged, elem);
                });

                $.each(surgicalActsMerged, function (index, elem) {
                    elem.data = elem.om_id;
                    if (elem.lateralization != '-1') {
                        elem.label = elem.description + ' - ' + elem.lateralization_desc;
                        /*} else {
                            //elem.label = elem.description;
                        }*/

                        /*var uniq_ids = [];
                        $.each(surgicalActsMergedUniques, function(idx, uniq){
                            uniq_ids.push(uniq.data);
                        });

                        if($.inArray(elem.data, uniq_ids) === -1) {
                            surgicalActsMergedUniques.push(elem);
                        }*/

                        surgicalActsMergedUniques.push(elem);
                    }
                });

                //this.options.nosologic_group_surgical_acts = surgicalActsMergedUniques;

            }else{

                debug.log('getSurgicalActs : from DB: ', this.options.urlParams);


                $.ajaxSetup({
                    async: false
                });


                $.getJSON('/surgery/get_surgery_medical_acts', this.options.urlParams)
                    .done(function (data, status, xhr) {
                        Hades.checkIfUserIsAuthorized(data, status, xhr);
                        debug.log('load_cenas: ', data);

                        //this.options.nosologic_group_surgical_acts = data;
                        surgicalActsMergedUniques = data;

                        Hades.hideLoading();

                    })
                    .fail(function (xhr, status, error) {
                        Hades.showError(error, xhr.responseText, xhr, status, error);
                        Hades.hideLoading();
                    });


                $.ajaxSetup({
                    async: true
                });

            }

            //return surgicalActsMerged;
            return surgicalActsMergedUniques;
        },
        drawSurgicalActs: function (selected_surgical_acts, surgicalActs) {
            debug.log('drawSurgicalActs: ', selected_surgical_acts, surgicalActs);
            var multiSelect = '';
            var that = this;
            //var surgicalActs = this.getSurgicalActs();

            if (!surgicalActs || surgicalActs.length == 0) {
                surgicalActs = this.getSurgicalActs();

                //this.getSurgicalActs();

                //setTimeout(function(){

                    //Hades.showLoading();
                   // surgicalActs = that.getSurgicalActs(); //this.options.nosologic_group_surgical_acts;

               // }, 5000);

            }

            if (selected_surgical_acts){
                $.each(surgicalActs, function (index, elem) {

                    //var in_array = $.inArray(elem.om_id + "", selected_surgical_acts);

                    /*
                     debug.log('in_array', in_array, elem.om_id, selected_surgical_acts);
                    for(var i = 0; i < selected_surgical_acts.length; i++){
                        debug.log('selected_surgical_acts[i]', selected_surgical_acts[i]);
                        debug.log('elem.om_id', elem.om_id)
                        if(elem.om_id == selected_surgical_acts[i]){
                            debug.log('É IGUAL');
                        }
                    }*/
                    // if elem.data IN (selected_surgical_acts) then 'selected="selected"' else '' end if;
                    var ng_index = 0;
                    var last_ng_id = 0;
                    var in_array = false;
                    $.each(selected_surgical_acts, function(index, selected_elem) {
                        if (index == 0) {
                            last_ng_id = selected_elem.nosologic_group_id;
                        } else {
                            if (last_ng_id != selected_elem.nosologic_group_id) {
                                last_ng_id = selected_elem.nosologic_group_id;
                                ng_index = ng_index + 1;
                            }
                        }
                        debug.log('XPTO PARTIC MA: ', selected_elem, elem, $('[role=nosologic-group-container]').data('id'), selected_elem.nosologic_group_id, $('[role=nosologic-group-container][data-id='+ selected_elem.nosologic_group_id +']'), $('[role=nosologic-group-container][data-id='+ selected_elem.nosologic_group_id +']').data('index'));
                        if ( $('[role=nosologic-group-container][data-id='+ selected_elem.nosologic_group_id +']').length > 0 ){

                            ng_index = $('[role=nosologic-group-container][data-id='+ selected_elem.nosologic_group_id +']').data('index');
                        }

                        if(elem.om_id == selected_elem.medical_act_id && elem.lateralization == selected_elem.laterality_id && (ng_index == elem.ng_index || selected_elem.nosologic_group_id == elem.ng_index)) {

                            in_array = true;
                        }
                    });

                    if (in_array == true){
                        multiSelect = multiSelect + '<option value="' + elem.data + '" data-lateralization = "' + elem.lateralization + '"  data-ng_index="' + elem.ng_index + '" om_id="' + elem.om_id + '" code="' + elem.code + '" selected="selected">' +  elem.label + '</option>';
                    }else{
                        multiSelect = multiSelect + '<option value="' + elem.data + '" data-lateralization = "' + elem.lateralization + '" data-ng_index="' + elem.ng_index + '" om_id="' + elem.om_id + '" code="' + elem.code + '">' +  elem.label + '</option>';
                    }


                });

            } else {
                $.each(surgicalActs, function (index, elem) {
                    multiSelect = multiSelect + '<option value="' + elem.data + '" data-lateralization = "' + elem.lateralization + '" data-ng_index="' + elem.ng_index + '" om_id="' + elem.om_id + '" code="' + elem.code + '">' +  elem.label + '</option>';
                });
            }

            return multiSelect;
        },
        onUpdateSurgicalActs: function(ng_id){
            //debug.log('khis.participantSelector - onUpdateSurgicalActs');

            var selects = $('#participants').find('select[role=participant_surgical_act]');
            var that = this;

            var index = ng_id;


            $.each(selects, function (idx, select) {
                var surgicalActIds = [];

                $.each($(select).find('option'), function (idx, opt) {
                    debug.log('onUpdateSurgicalActs', $(opt), index, select, selects);

                    if ( $(opt).data('ng_index') != null && $(opt).data('ng_index') !== 'undifined' ) {
                        debug.log('entrei');
                        index = $(opt).data('ng_index');
                    }

                    if($(opt).attr('selected')){
                        surgicalActIds.push({medical_act_id: $(opt).val(), laterality_id: $(opt).data('lateralization') , nosologic_group_id: index});
                    }

                });

                if(surgicalActIds.length <= 0){
                    surgicalActIds = null;
                }

                debug.log('onUpdateSurgicalActs surgicalActIds: ', surgicalActIds);

                $(select).find('option').remove();
                $(select).append('<option value="-999">Todos</option>');
                $(select).append(that.drawSurgicalActs(surgicalActIds));
                $(select).trigger('liszt:updated');

            });
        },
        onMultiSelectChange: function(evt, changes) {
            //When '-999' means to select all, so all are selected ('-999' is never seen as selected, it is only a "bypass" to "all selected")
            if(changes){

                if (changes.selected == '-999'){
                    $.each($(evt.target).find('option'), function (index, elem) {

                        if ($(elem).val() == '-999') {
                            $(elem).prop('selected', false);
                        } else {
                            $(elem).attr('selected', 'selected');
                        }
                    });
                } else if(changes.selected){
                    $.each($(evt.target).find('option'), function (index, elem) {

                        if ($(elem).val() == changes.selected) {
                            $(elem).attr('selected', 'selected');
                        }

                    });
                } else if(changes.deselected){
                    $.each($(evt.target).find('option'), function (index, elem) {

                        if ($(elem).val() == changes.deselected) {
                            $(elem).removeAttr('selected');
                        }

                    });
                }

            }

            $(evt.target).trigger('liszt:updated');
        }
    });

})();

